/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { ProductInformationFragmentDoc } from "../../products/graphql/product-information.fragments.generated"
import { ProductPositionFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type ProductPositionQueryVariables = Exact<{
  id: string
}>

export type ProductPositionQuery = {
  __typename: "Query"
  productPosition?: {
    __typename: "ProductPosition"
    id: string
    label?: string | null
    variantKey: string
    configurationKey?: string | null
    remark?: string | null
    quantity: number
    position: number
    displayPosition?: string | null
    isAlternative?: boolean | null
    price?: number | null
    priceGroup?: string | null
    hasClarificationRequest?: boolean | null
    references?: Array<{
      __typename: "ProductPositionInstallationReference"
      id: string
      title?: string | null
      permalink: string
      position: number
    }> | null
    addons?: Array<{
      __typename: "ProductPositionAddon"
      id: string
      variantKey: string
      parentProductType: string
    }> | null
    dimensioning?: {
      __typename: "ExternalDimensioningResult"
      transactionId: string
      environmentalVars?: Array<any> | null
      variantKeyData?: any
      dllVersion?: string | null
      language?: string | null
      technicalData?: Array<
        | {
            __typename: "ExternalDimensioningTechnicalDataDllVersion"
            dllVersion: string
          }
        | {
            __typename: "ExternalDimensioningTechnicalDataTable"
            header?: Array<string> | null
            content?: any
            summary?: string | null
            type?: string | null
          }
      > | null
      technicalInput?: Array<{
        __typename: "ExternalDimensioningTechnicalInput"
        name: string
        label?: string | null
        unit?: string | null
        value?: any
        userSelected: boolean
      }> | null
      supplementaryText?: Array<{
        __typename: "ExternalDimensioningSupplementaryText"
        text: string
      }> | null
      transferData?: {
        __typename: "ExternalDimensioningTransferData"
        origin?: string | null
      } | null
    } | null
  } | null
}

export type ProductPositionsQueryVariables = Exact<{
  parentID: string
}>

export type ProductPositionsQuery = {
  __typename: "Query"
  productPositions?: Array<{
    __typename: "ProductPosition"
    id: string
    label?: string | null
    variantKey: string
    configurationKey?: string | null
    remark?: string | null
    quantity: number
    position: number
    displayPosition?: string | null
    isAlternative?: boolean | null
    price?: number | null
    priceGroup?: string | null
    hasClarificationRequest?: boolean | null
    references?: Array<{
      __typename: "ProductPositionInstallationReference"
      id: string
      title?: string | null
      permalink: string
      position: number
    }> | null
    addons?: Array<{
      __typename: "ProductPositionAddon"
      id: string
      variantKey: string
      parentProductType: string
    }> | null
    dimensioning?: {
      __typename: "ExternalDimensioningResult"
      transactionId: string
      environmentalVars?: Array<any> | null
      variantKeyData?: any
      dllVersion?: string | null
      language?: string | null
      technicalData?: Array<
        | {
            __typename: "ExternalDimensioningTechnicalDataDllVersion"
            dllVersion: string
          }
        | {
            __typename: "ExternalDimensioningTechnicalDataTable"
            header?: Array<string> | null
            content?: any
            summary?: string | null
            type?: string | null
          }
      > | null
      technicalInput?: Array<{
        __typename: "ExternalDimensioningTechnicalInput"
        name: string
        label?: string | null
        unit?: string | null
        value?: any
        userSelected: boolean
      }> | null
      supplementaryText?: Array<{
        __typename: "ExternalDimensioningSupplementaryText"
        text: string
      }> | null
      transferData?: {
        __typename: "ExternalDimensioningTransferData"
        origin?: string | null
      } | null
    } | null
  }> | null
}

export type ProductPositionProductInformationQueryVariables = Exact<{
  id: string
}>

export type ProductPositionProductInformationQuery = {
  __typename: "Query"
  productPositionProductInformation?: {
    __typename: "ProductInformation"
    productType: string
    variantKey: string
    configurationKey?: string | null
    title: string
    shortTitle: string
    productKind: string
    price?: number | null
    priceGroup?: string | null
    addons?: Array<{
      __typename: "ProductInformation"
      productType: string
      variantKey: string
      configurationKey?: string | null
      title: string
      shortTitle: string
      productKind: string
      price?: number | null
      priceGroup?: string | null
      attributes: Array<{
        __typename: "ProductAttribute"
        value: string
        label: string
        valueShort?: string | null
      }>
      picture?: {
        __typename: "ProductPicture"
        url: string
        title?: string | null
        alternativeText?: string | null
      } | null
      quickInfos?: {
        __typename: "ProductInformationTextField"
        label: string
        value: string
      } | null
      generalDescription?: {
        __typename: "ProductInformationTextField"
        label: string
        value: string
      } | null
      variantDescription?: {
        __typename: "ProductInformationTextField"
        label: string
        value: string
      } | null
      attributesTable?: {
        __typename: "DataTable"
        description?: string | null
        body?: Array<Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null> | null
        header?: Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null
      } | null
      dimensioning?: {
        __typename: "ProductDimensioning"
        supplementaryText?: string | null
        environmentalAttributes?: Array<{
          __typename: "ProductAttribute"
          value: string
          label: string
          valueShort?: string | null
        }> | null
        physicalAttributes?: Array<{
          __typename: "PhysicalAttribute"
          value?: number | null
          unit?: string | null
          label: string
        }> | null
        physicalTables?: Array<{
          __typename: "DataTable"
          description?: string | null
          body?: Array<Array<{
            __typename: "DataTableCell"
            index?: number | null
            key?: string | null
            value?: any
          }> | null> | null
          header?: Array<{
            __typename: "DataTableCell"
            index?: number | null
            key?: string | null
            value?: any
          }> | null
        }> | null
      } | null
      deliveryTime?: {
        __typename: "ProductDeliveryTime"
        type: string
        days?: number | null
        week?: number | null
        quarter?: number | null
        year?: number | null
      } | null
    }> | null
    attributes: Array<{
      __typename: "ProductAttribute"
      value: string
      label: string
      valueShort?: string | null
    }>
    picture?: {
      __typename: "ProductPicture"
      url: string
      title?: string | null
      alternativeText?: string | null
    } | null
    quickInfos?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    generalDescription?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    variantDescription?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    attributesTable?: {
      __typename: "DataTable"
      description?: string | null
      body?: Array<Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null> | null
      header?: Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null
    } | null
    dimensioning?: {
      __typename: "ProductDimensioning"
      supplementaryText?: string | null
      environmentalAttributes?: Array<{
        __typename: "ProductAttribute"
        value: string
        label: string
        valueShort?: string | null
      }> | null
      physicalAttributes?: Array<{
        __typename: "PhysicalAttribute"
        value?: number | null
        unit?: string | null
        label: string
      }> | null
      physicalTables?: Array<{
        __typename: "DataTable"
        description?: string | null
        body?: Array<Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null> | null
        header?: Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null
      }> | null
    } | null
    deliveryTime?: {
      __typename: "ProductDeliveryTime"
      type: string
      days?: number | null
      week?: number | null
      quarter?: number | null
      year?: number | null
    } | null
  } | null
}

export type ProductPositionProductInformationByShareLinkQueryVariables = Exact<{
  id: string
  projectShareID: string
}>

export type ProductPositionProductInformationByShareLinkQuery = {
  __typename: "Query"
  productPositionProductInformationByShareLink?: {
    __typename: "ProductInformation"
    productType: string
    variantKey: string
    configurationKey?: string | null
    title: string
    shortTitle: string
    productKind: string
    price?: number | null
    priceGroup?: string | null
    addons?: Array<{
      __typename: "ProductInformation"
      productType: string
      variantKey: string
      configurationKey?: string | null
      title: string
      shortTitle: string
      productKind: string
      price?: number | null
      priceGroup?: string | null
      attributes: Array<{
        __typename: "ProductAttribute"
        value: string
        label: string
        valueShort?: string | null
      }>
      picture?: {
        __typename: "ProductPicture"
        url: string
        title?: string | null
        alternativeText?: string | null
      } | null
      quickInfos?: {
        __typename: "ProductInformationTextField"
        label: string
        value: string
      } | null
      generalDescription?: {
        __typename: "ProductInformationTextField"
        label: string
        value: string
      } | null
      variantDescription?: {
        __typename: "ProductInformationTextField"
        label: string
        value: string
      } | null
      attributesTable?: {
        __typename: "DataTable"
        description?: string | null
        body?: Array<Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null> | null
        header?: Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null
      } | null
      dimensioning?: {
        __typename: "ProductDimensioning"
        supplementaryText?: string | null
        environmentalAttributes?: Array<{
          __typename: "ProductAttribute"
          value: string
          label: string
          valueShort?: string | null
        }> | null
        physicalAttributes?: Array<{
          __typename: "PhysicalAttribute"
          value?: number | null
          unit?: string | null
          label: string
        }> | null
        physicalTables?: Array<{
          __typename: "DataTable"
          description?: string | null
          body?: Array<Array<{
            __typename: "DataTableCell"
            index?: number | null
            key?: string | null
            value?: any
          }> | null> | null
          header?: Array<{
            __typename: "DataTableCell"
            index?: number | null
            key?: string | null
            value?: any
          }> | null
        }> | null
      } | null
      deliveryTime?: {
        __typename: "ProductDeliveryTime"
        type: string
        days?: number | null
        week?: number | null
        quarter?: number | null
        year?: number | null
      } | null
    }> | null
    attributes: Array<{
      __typename: "ProductAttribute"
      value: string
      label: string
      valueShort?: string | null
    }>
    picture?: {
      __typename: "ProductPicture"
      url: string
      title?: string | null
      alternativeText?: string | null
    } | null
    quickInfos?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    generalDescription?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    variantDescription?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    attributesTable?: {
      __typename: "DataTable"
      description?: string | null
      body?: Array<Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null> | null
      header?: Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null
    } | null
    dimensioning?: {
      __typename: "ProductDimensioning"
      supplementaryText?: string | null
      environmentalAttributes?: Array<{
        __typename: "ProductAttribute"
        value: string
        label: string
        valueShort?: string | null
      }> | null
      physicalAttributes?: Array<{
        __typename: "PhysicalAttribute"
        value?: number | null
        unit?: string | null
        label: string
      }> | null
      physicalTables?: Array<{
        __typename: "DataTable"
        description?: string | null
        body?: Array<Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null> | null
        header?: Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null
      }> | null
    } | null
    deliveryTime?: {
      __typename: "ProductDeliveryTime"
      type: string
      days?: number | null
      week?: number | null
      quarter?: number | null
      year?: number | null
    } | null
  } | null
}

export const ProductPositionDocument = gql`
  query ProductPosition($id: ID!) {
    productPosition(id: $id)
      @rest(
        type: "ProductPosition"
        endpoint: "productPosition"
        path: "/project-list/project-positions/{args.id}"
      ) {
      ...ProductPosition
    }
  }
  ${ProductPositionFragmentDoc}
`

/**
 * __useProductPositionQuery__
 *
 * To run a query within a React component, call `useProductPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPositionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductPositionQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductPositionQuery,
    ProductPositionQueryVariables
  > &
    (
      | { variables: ProductPositionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProductPositionQuery, ProductPositionQueryVariables>(
    ProductPositionDocument,
    options
  )
}
export function useProductPositionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductPositionQuery,
    ProductPositionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductPositionQuery,
    ProductPositionQueryVariables
  >(ProductPositionDocument, options)
}
// @ts-ignore
export function useProductPositionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductPositionQuery,
    ProductPositionQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProductPositionQuery,
  ProductPositionQueryVariables
>
export function useProductPositionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPositionQuery,
        ProductPositionQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProductPositionQuery | undefined,
  ProductPositionQueryVariables
>
export function useProductPositionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPositionQuery,
        ProductPositionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProductPositionQuery,
    ProductPositionQueryVariables
  >(ProductPositionDocument, options)
}
export type ProductPositionQueryHookResult = ReturnType<
  typeof useProductPositionQuery
>
export type ProductPositionLazyQueryHookResult = ReturnType<
  typeof useProductPositionLazyQuery
>
export type ProductPositionSuspenseQueryHookResult = ReturnType<
  typeof useProductPositionSuspenseQuery
>
export type ProductPositionQueryResult = Apollo.QueryResult<
  ProductPositionQuery,
  ProductPositionQueryVariables
>
export const ProductPositionsDocument = gql`
  query ProductPositions($parentID: ID!) {
    productPositions(parentID: $parentID)
      @rest(
        type: "ProductPosition"
        endpoint: "productPosition"
        path: "/project-list/projects/{args.parentID}/project-positions"
      ) {
      ...ProductPosition
    }
  }
  ${ProductPositionFragmentDoc}
`

/**
 * __useProductPositionsQuery__
 *
 * To run a query within a React component, call `useProductPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPositionsQuery({
 *   variables: {
 *      parentID: // value for 'parentID'
 *   },
 * });
 */
export function useProductPositionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductPositionsQuery,
    ProductPositionsQueryVariables
  > &
    (
      | { variables: ProductPositionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProductPositionsQuery, ProductPositionsQueryVariables>(
    ProductPositionsDocument,
    options
  )
}
export function useProductPositionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductPositionsQuery,
    ProductPositionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductPositionsQuery,
    ProductPositionsQueryVariables
  >(ProductPositionsDocument, options)
}
// @ts-ignore
export function useProductPositionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductPositionsQuery,
    ProductPositionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProductPositionsQuery,
  ProductPositionsQueryVariables
>
export function useProductPositionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPositionsQuery,
        ProductPositionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProductPositionsQuery | undefined,
  ProductPositionsQueryVariables
>
export function useProductPositionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPositionsQuery,
        ProductPositionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProductPositionsQuery,
    ProductPositionsQueryVariables
  >(ProductPositionsDocument, options)
}
export type ProductPositionsQueryHookResult = ReturnType<
  typeof useProductPositionsQuery
>
export type ProductPositionsLazyQueryHookResult = ReturnType<
  typeof useProductPositionsLazyQuery
>
export type ProductPositionsSuspenseQueryHookResult = ReturnType<
  typeof useProductPositionsSuspenseQuery
>
export type ProductPositionsQueryResult = Apollo.QueryResult<
  ProductPositionsQuery,
  ProductPositionsQueryVariables
>
export const ProductPositionProductInformationDocument = gql`
  query ProductPositionProductInformation($id: ID!) {
    productPositionProductInformation(id: $id)
      @rest(
        type: "ProductInformation"
        path: "/project-list/project-positions/{args.id}/product-info"
      ) {
      ...ProductInformation
    }
  }
  ${ProductInformationFragmentDoc}
`

/**
 * __useProductPositionProductInformationQuery__
 *
 * To run a query within a React component, call `useProductPositionProductInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPositionProductInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPositionProductInformationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductPositionProductInformationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductPositionProductInformationQuery,
    ProductPositionProductInformationQueryVariables
  > &
    (
      | {
          variables: ProductPositionProductInformationQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductPositionProductInformationQuery,
    ProductPositionProductInformationQueryVariables
  >(ProductPositionProductInformationDocument, options)
}
export function useProductPositionProductInformationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductPositionProductInformationQuery,
    ProductPositionProductInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductPositionProductInformationQuery,
    ProductPositionProductInformationQueryVariables
  >(ProductPositionProductInformationDocument, options)
}
// @ts-ignore
export function useProductPositionProductInformationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductPositionProductInformationQuery,
    ProductPositionProductInformationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProductPositionProductInformationQuery,
  ProductPositionProductInformationQueryVariables
>
export function useProductPositionProductInformationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPositionProductInformationQuery,
        ProductPositionProductInformationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProductPositionProductInformationQuery | undefined,
  ProductPositionProductInformationQueryVariables
>
export function useProductPositionProductInformationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPositionProductInformationQuery,
        ProductPositionProductInformationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProductPositionProductInformationQuery,
    ProductPositionProductInformationQueryVariables
  >(ProductPositionProductInformationDocument, options)
}
export type ProductPositionProductInformationQueryHookResult = ReturnType<
  typeof useProductPositionProductInformationQuery
>
export type ProductPositionProductInformationLazyQueryHookResult = ReturnType<
  typeof useProductPositionProductInformationLazyQuery
>
export type ProductPositionProductInformationSuspenseQueryHookResult =
  ReturnType<typeof useProductPositionProductInformationSuspenseQuery>
export type ProductPositionProductInformationQueryResult = Apollo.QueryResult<
  ProductPositionProductInformationQuery,
  ProductPositionProductInformationQueryVariables
>
export const ProductPositionProductInformationByShareLinkDocument = gql`
  query ProductPositionProductInformationByShareLink(
    $id: ID!
    $projectShareID: ID!
  ) {
    productPositionProductInformationByShareLink(
      id: $id
      projectShareID: $projectShareID
    )
      @rest(
        type: "ProductInformation"
        path: "/project-list/share-links/{args.projectShareID}/project-positions/{args.id}/product-info"
      ) {
      ...ProductInformation
    }
  }
  ${ProductInformationFragmentDoc}
`

/**
 * __useProductPositionProductInformationByShareLinkQuery__
 *
 * To run a query within a React component, call `useProductPositionProductInformationByShareLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPositionProductInformationByShareLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPositionProductInformationByShareLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *      projectShareID: // value for 'projectShareID'
 *   },
 * });
 */
export function useProductPositionProductInformationByShareLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductPositionProductInformationByShareLinkQuery,
    ProductPositionProductInformationByShareLinkQueryVariables
  > &
    (
      | {
          variables: ProductPositionProductInformationByShareLinkQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductPositionProductInformationByShareLinkQuery,
    ProductPositionProductInformationByShareLinkQueryVariables
  >(ProductPositionProductInformationByShareLinkDocument, options)
}
export function useProductPositionProductInformationByShareLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductPositionProductInformationByShareLinkQuery,
    ProductPositionProductInformationByShareLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductPositionProductInformationByShareLinkQuery,
    ProductPositionProductInformationByShareLinkQueryVariables
  >(ProductPositionProductInformationByShareLinkDocument, options)
}
// @ts-ignore
export function useProductPositionProductInformationByShareLinkSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductPositionProductInformationByShareLinkQuery,
    ProductPositionProductInformationByShareLinkQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProductPositionProductInformationByShareLinkQuery,
  ProductPositionProductInformationByShareLinkQueryVariables
>
export function useProductPositionProductInformationByShareLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPositionProductInformationByShareLinkQuery,
        ProductPositionProductInformationByShareLinkQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProductPositionProductInformationByShareLinkQuery | undefined,
  ProductPositionProductInformationByShareLinkQueryVariables
>
export function useProductPositionProductInformationByShareLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPositionProductInformationByShareLinkQuery,
        ProductPositionProductInformationByShareLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProductPositionProductInformationByShareLinkQuery,
    ProductPositionProductInformationByShareLinkQueryVariables
  >(ProductPositionProductInformationByShareLinkDocument, options)
}
export type ProductPositionProductInformationByShareLinkQueryHookResult =
  ReturnType<typeof useProductPositionProductInformationByShareLinkQuery>
export type ProductPositionProductInformationByShareLinkLazyQueryHookResult =
  ReturnType<typeof useProductPositionProductInformationByShareLinkLazyQuery>
export type ProductPositionProductInformationByShareLinkSuspenseQueryHookResult =
  ReturnType<
    typeof useProductPositionProductInformationByShareLinkSuspenseQuery
  >
export type ProductPositionProductInformationByShareLinkQueryResult =
  Apollo.QueryResult<
    ProductPositionProductInformationByShareLinkQuery,
    ProductPositionProductInformationByShareLinkQueryVariables
  >
